import { alertProtocolAction } from "app/store/alertProtocol/actions/alertProtocolAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedContent: null,
  isEditModalOpen: false,
  isEditMode: false,
  isCopyMode: false,
  filterAccount: "",
  filterDeviceType: "",
  alertProtocols: [],
};

const alertProtocolSlice = createSlice({
  name: "alertProtocol",
  initialState: initialState,
  reducers: alertProtocolAction,
});

export const {
  setSelectedContent,
  setIsEditModalOpen,
  setIsEditMode,
  setIsCopyMode,
  clearSelectedContent,
  setFilterAccount,
  setFilterDeviceType,
  setAlertProtocols,
} = alertProtocolSlice.actions;

export default alertProtocolSlice.reducer;
